import { render, staticRenderFns } from "./ThumbnailProduct.vue?vue&type=template&id=2f5b2fd4&scoped=true&"
import script from "./ThumbnailProduct.vue?vue&type=script&lang=js&"
export * from "./ThumbnailProduct.vue?vue&type=script&lang=js&"
import style0 from "./ThumbnailProduct.vue?vue&type=style&index=0&id=2f5b2fd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5b2fd4",
  null
  
)

export default component.exports